import f from "../../funcs";
import $ from "jquery";
import Events from "../Events";
import ScrollTrack from "./ScrollTrack";
import DragDrop from "../DragDrop";


let ScrollBar = Events.extend("ScrollBar", {
    _trackWidth: 10,
    _trackHeight: 10,
    wheelStep: 21,


    init(params) {
        params = params || {};

        this.$el = $("<div class='ScrollBar'></div>");
        this.el = this.$el[0];

        if ( params.$box || params.box ) {
            f.initBox.call(this, params);
            this.$el.appendTo(this.$box);
        }

        this.viewport = {
            width: 0,
            height: 0
        };
        this.overview = {
            width: 0,
            height: 0,
            realHeight: 0
        };
        this.pageHeight = 0;
        this.pagePosition = 0;

        this.marginTop = params.marginTop;
        this.marginLeft = params.marginLeft;
        this.marginBottom = params.marginBottom;

        this.heightTrack = new ScrollTrack({
            wheelStep: this.wheelStep,
            box: this.el,
            orientation: "vertical"
        });
        this.heightTrack.on("move", (e) => {
            if ( !this._pauseUpdateEvent ) {
                this.trigger("moveTop", e.position, e.delta);
            }
        });
        this.heightTrack.el.style.marginTop = this.marginTop + "px";

        this.widthTrack = new ScrollTrack({
            box: this.el,
            orientation: "horizontal"
        });
        this.widthTrack.on("move", (e) => {
            if ( !this._pauseUpdateEvent ) {
                this.trigger("moveLeft", e.position);
            }
        });
        this.widthTrack.el.style.marginLeft = this.marginLeft + "px";
        this.widthTrack.el.style.marginBottom = this.marginBottom + "px";

        if ( this.$box ) {
            this.heightTrack.listenWheel(this.$box);
        }

        // @see CellClick
        let onEnd = () => {
            this._scrollEnded = true;
            setTimeout(() => {
                this._scrollEnded = false;
            }, 10);
        };

        this.heightTrack.on("end", onEnd);
        this.widthTrack.on("end", onEnd);

        this.listenTo(this.heightTrack, "beforeWheel", (e) => {

            if ( params.pageScroll !== false && this.pageHeight > this.viewport.height ) {
                let delta = e.delta;
                let min = 0;
                let max = this.pageHeight - this.viewport.height;

                if (
                    delta > 0 && this.pagePosition < max
                        || delta < 0 && this.pagePosition > min
                ) {
                    this.pagePosition += delta;
                    this.pagePosition = Math.min(this.pagePosition, max);
                    this.pagePosition = Math.max(this.pagePosition, min);

                    e.preventWheel();
                    this.trigger("pageScroll", e);

                    return;
                }
            }

            this.trigger("beforeWheel", e);
        });

        if ( this.$box && params.touch ) {
            this.initTouch();
        }
    },

    setViewport(viewport) {
        if ( f.isNumber(viewport.width) ) {
            this.viewport.width = viewport.width;
        }
        if ( f.isNumber(viewport.height) ) {
            this.viewport.height = viewport.height;
            this.pageHeight = this.viewport.height;
        }
    },

    setOverview(overview) {
        if ( f.isNumber(overview.width) ) {
            this.overview.width = overview.width;
        }
        if ( f.isNumber(overview.height) ) {
            this.overview.height = overview.height;
        }
    },

    // скролл трапециуй
    setInner(inner) {
        if ( "width" in inner ) {
            this.inner.width = inner.width;
        }
        if ( "height" in inner ) {
            this.inner.height = inner.height;
        }
    },

    update(options) {
        options = f.deepMixin({ trigger: true }, options);

        this.heightTrack.setViewport(this.viewport.height);
        this.heightTrack.setOverview(this.overview.height);
        this.heightTrack.setPosition(this.heightTrack.position, options);

        this.widthTrack.setViewport(this.viewport.width);
        this.widthTrack.setOverview(this.overview.width);
        this.widthTrack.setPosition(this.widthTrack.position, options);

        this.heightTrack.draw();
        this.widthTrack.draw();
    },

    setPageHeight(pageHeight) {
        this.pageHeight = pageHeight;

        ///// ---- зверский костыль, который работает на пару с behavior/Scroll.js
        let max = Math.max(this.pageHeight - this.viewport.height, 0);

        if ( this.pagePosition > max ) {
            let delta = this.pagePosition - max;
            this.pagePosition = max;
            this.trigger("pageScroll", {
                delta
            });
        }
        ///// ----
    },

    getTop() {
        return this.heightTrack.position;
    },

    getLeft() {
        return this.widthTrack.position;
    },

    setTop(top, options) {
        this.heightTrack.setPosition(top, options);
    },

    setLeft(left) {
        this.widthTrack.setPosition(left);
    },

    // @see GridList
    pauseUpdateEvent() {
        this._pauseUpdateEvent = true;
    },

    playUpdateEvent() {
        this._pauseUpdateEvent = false;
    },

    initTouch() {
        this.touchDragDrop = new DragDrop({
            mouse: false
        });
        this.touchDragDrop.addElem(this.$box);

        this.listenTo(this.touchDragDrop, "start", this.onStartTouch);
        this.listenTo(this.touchDragDrop, "move", this.onMoveTouch);
        this.listenTo(this.touchDragDrop, "end", this.onEndTouch);
    },

    onStartTouch(e) {
        e.set("left", this.getLeft());
        e.set("top", this.getTop());
        e.set("startTime", Date.now());

        clearInterval(this._touchInterval);
    },

    onMoveTouch(e) {
        this.setLeft(e.start.get("left") - e.dx);
        this.setTop(e.start.get("top") - e.dy);
    },

    onEndTouch(e) {
        clearInterval(this._touchInterval);

        if ( !e.dx && !e.dy ) {
            return;
        }

        let currentTime = Date.now();
        let diffTime = currentTime - e.start.get("startTime");
        let px2ms = Math.max(Math.sqrt(e.dx * e.dx + e.dy * e.dy), 1) / Math.max(diffTime, 1);

        let to = {
            x: this.getLeft() - e.dx * px2ms,
            y: this.getTop() - e.dy * px2ms
        };

        this._touchInterval = setInterval(() => {
            let current = {
                x: this.getLeft(),
                y: this.getTop()
            };

            let step = {
                x: (to.x - current.x) / 5,
                y: (to.y - current.y) / 5
            };

            this.setLeft(current.x + step.x);
            this.setTop(current.y + step.y);

            if ( Math.abs(step.x) <= 1 && Math.abs(step.y) <= 1 ) {
                clearInterval(this._touchInterval);
            }
        }, 50);
    },

    destroy() {
        clearInterval(this._touchInterval);

        if ( this.touchDragDrop ) {
            this.touchDragDrop.destroy();
        }

        this.heightTrack.destroy();
        this.widthTrack.destroy();
        this.clearEvents();
    }

});

export default ScrollBar;
